import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

export const styles: { [key: string]: CSSProperties } = {
  icon: {
    position: 'relative'
  },
  spinner: {
    top: '50%',
    margin: 'auto',
    border: `4px solid ${AppColors.VA.PRIMARY._50_}`,
    borderLeftColor: 'transparent',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    animation: 'spin 1s linear infinite'
  }
};
